import React from 'react';
import { Card, Descriptions, Typography, Tag } from 'antd';
import { settings } from '../../mockData';
import './Security.css';

function SecurityAccess() {
  const { Title } = Typography;
  const security = settings.security;

  return (
    <div className="agency-settings-security">
      <Title level={3}>Security & Access Control</Title>
      <Card>
        <Descriptions column={1} bordered size="small">
          <Descriptions.Item label="Two-Factor Auth">
            <Tag color={security.twoFA ? 'green' : 'red'}>{security.twoFA ? 'ENABLED' : 'DISABLED'}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Last Password Change">{security.lastPasswordChange}</Descriptions.Item>
          <Descriptions.Item label="Allowed IPs">
            {(security.allowedIPs || []).map((ip) => (
              <Tag key={ip}>{ip}</Tag>
            ))}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </div>
  );
}

export default SecurityAccess;
